import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/brand";
import { useLanguage } from "@/i18n/LanguageContext";
import { BRAND } from "@/lib/brand";

const exploreLinks = (t) => [
  { label: t.nav.about, href: "/about" },
  { label: t.nav.services, href: "/services" },
  { label: t.nav.contact, href: "/contact" },
];

const legalLinks = [
  { label_en: "Privacy Policy", label_es: "Política de Privacidad", href: "/privacy-policy" },
  { label_en: "Terms and Conditions", label_es: "Términos y Condiciones", href: "/terms-and-conditions" },
  { label_en: "Refund Policy", label_es: "Política de Reembolsos", href: "/refund-policy" },
  { label_en: "Data Deletion", label_es: "Eliminación de Datos", href: "/data-deletion" },
  { label_en: "Legal Information", label_es: "Información Legal", href: "/legal" },
  { label_en: "Company Information", label_es: "Información de la Empresa", href: "/company-information" },
];

export default function Footer() {
  const { t, lang } = useLanguage();

  return (
    <footer
      className="mt-24 text-white"
      style={{ background: "var(--brand-primary)" }}
      data-testid="site-footer"
    >
      <div className="container-brand py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span
                className="inline-flex items-center justify-center rounded-full overflow-hidden"
                style={{ width: 40, height: 40, background: "#fff" }}
              >
                <img
                  src={LOGO_URL}
                  alt="BrandLabAI"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </span>
              <div>
                <p className="font-display font-bold text-lg leading-none">BrandLabAI</p>
                <p className="text-xs opacity-80 mt-1">{t.common.tagline}</p>
              </div>
            </div>
            <p className="text-sm opacity-90 mt-5 max-w-md leading-relaxed">
              {t.meta.description}
            </p>
          </div>

          {/* Explore (main nav links) */}
          <div className="md:col-span-3">
            <p className="font-display font-semibold text-sm uppercase tracking-[0.14em] opacity-80 mb-4">
              {lang === "es" ? "Explora" : "Explore"}
            </p>
            <ul className="space-y-2.5">
              {exploreLinks(t).map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-sm hover:underline underline-offset-4 opacity-90 hover:opacity-100"
                    data-testid={`footer-explore-${l.href.replace(/[/]/g, "")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal (discreet) */}
          <div className="md:col-span-2">
            <p className="font-display font-semibold text-sm uppercase tracking-[0.14em] opacity-80 mb-4">
              {t.common.legalSurface}
            </p>
            <ul className="space-y-2.5">
              {legalLinks.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-sm hover:underline underline-offset-4 opacity-90 hover:opacity-100"
                    data-testid={`footer-legal-${l.href.replace(/[/]/g, "")}`}
                  >
                    {lang === "es" ? l.label_es : l.label_en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <p className="font-display font-semibold text-sm uppercase tracking-[0.14em] opacity-80 mb-4">
              {lang === "es" ? "Contacto" : "Contact"}
            </p>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="hover:underline underline-offset-4 opacity-95 hover:opacity-100"
                  data-testid="footer-email"
                >
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${BRAND.phoneHref}`}
                  className="hover:underline underline-offset-4 opacity-95 hover:opacity-100"
                  data-testid="footer-phone"
                >
                  {BRAND.phone}
                </a>
              </li>
              <li className="opacity-80">AI Brandcraft LLC</li>
              <li className="opacity-80">Florida, US · Quito, EC</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs opacity-75">© 2026 AI Brandcraft LLC. {lang === "es" ? "Todos los derechos reservados." : "All rights reserved."}</p>
          <p className="text-xs opacity-75">www.brandlab-ai.com</p>
        </div>
      </div>
    </footer>
  );
}
